import { render, staticRenderFns } from "./SmsEmailModal.vue?vue&type=template&id=1a82b406&scoped=true&"
import script from "./SmsEmailModal.vue?vue&type=script&lang=ts&"
export * from "./SmsEmailModal.vue?vue&type=script&lang=ts&"
import style0 from "./SmsEmailModal.vue?vue&type=style&index=0&id=1a82b406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a82b406",
  null
  
)

export default component.exports